















import { Component, mixins, Prop } from 'nuxt-property-decorator'
import ComponentImage from '~/components/images/image.vue'
import { IBrand } from '~/assets/interfaces/brands'
import ComponentIcon from '~/components/icon/icon.vue'
import MixinGeneral from '~/assets/mixins/general'

@Component({
  components: {
    ComponentIcon,
    ComponentImage,
  },
})
export default class ComponentBrandItem extends mixins(MixinGeneral) {
  @Prop({
    type: Object,
    default: () => {},
  })
  private item!: IBrand

  private mounted(): void {
    this.$emit('loaded')
  }
}
